var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33.9394,
    height: 33.9394,
    transform: "translate(0.178223)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1509_310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.2575 11.3631C22.6333 9.22293 20.1683 8 17.4995 8C14.8307 8 12.3658 9.22293 10.7416 11.3631C9.6078 12.8535 9.00908 14.6242 9.00908 16.4841C9.00908 18.0255 9.43583 19.5478 10.2447 20.879C11.8053 23.4395 14.5123 24.9682 17.4995 24.9682C20.4868 24.9682 23.1938 23.4395 24.7479 20.879C25.5568 19.5478 25.9836 18.0255 25.9836 16.4841C25.9836 14.6242 25.3849 12.8535 24.2575 11.3631ZM23.1174 19.8854C21.9072 21.8726 19.8116 23.0573 17.4995 23.0573C15.1874 23.0573 13.0855 21.8726 11.8817 19.8854C11.2511 18.8535 10.9199 17.6815 10.9199 16.4841C10.9199 15.0446 11.3849 13.6752 12.2639 12.5159C13.5186 10.8599 15.4295 9.91083 17.4995 9.91083C19.5696 9.91083 21.474 10.8599 22.7352 12.5159C23.6078 13.6752 24.0728 15.0446 24.0728 16.4841C24.0728 17.6815 23.7416 18.8535 23.1174 19.8854ZM7.90717 16.4841C7.90717 17.707 8.13647 18.8981 8.58869 20.0318L6.81162 20.7389C6.27022 19.3822 5.99634 17.949 5.99634 16.4841C5.99634 14.7516 6.37213 13.0828 7.11736 11.5287L8.84347 12.3503C8.22564 13.6497 7.90717 15.0382 7.90717 16.4841ZM28.1811 20.7389L26.404 20.0318C26.8562 18.8981 27.0855 17.707 27.0855 16.4841C27.0855 15.0382 26.7734 13.6497 26.1492 12.3503L27.8753 11.5287C28.6205 13.0828 28.9963 14.7516 28.9963 16.4841C28.9963 17.949 28.7225 19.3822 28.1811 20.7389Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1509_310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 16.9682,
    fill: "white",
    transform: "translate(5.99634 8)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAc);
export default __webpack_public_path__ + "static/media/ac.9ffe0b8cd7977cc0e0ead2d56e96ff68.svg";
export { ForwardRef as ReactComponent };